import SportOracle from './SportOracle';
import AdminPanel from './AdminPanel';

export default function App() {
  // Simple routing: /admin goes to admin panel
  const isAdmin = window.location.pathname === '/admin';
  return isAdmin ? <AdminPanel /> : <SportOracle />;
}
